"use client";

import React, { useRef } from "react";
import SectionHeader from "../common/section-header";
import Image from "next/image";
import { NumberTicker } from "../magicui/number-ticker";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";

function AbooutUsIntroduction() {
  const introRef = useRef(null);
  useGSAP(
    () => {
      const columns = gsap.utils.toArray(".intro-column");
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(
        columns,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".intro-column",
            start: "top 80%",
            toggleActions: "play none none reset",
          },
        },
      );
    },
    { scope: introRef },
  );

  return (
    <section
      id="introduction"
      ref={introRef}
      className="relative overflow-hidden px-8 font-Satoshi-Variable lg:px-10"
    >
      <SectionHeader
        highlightedTitle="Rake Engineering Consultancy"
        bodyText="Building the future with precision, expertise, and unwavering commitment to excellence in engineering and consultancy services."
      />
      {/* Mission Section */}
      <article className="w-full bg-white pb-20 pt-20 lg:pt-5">
        <div className="mx-auto w-full max-w-7xl">
          <div className="flex w-full flex-col items-center gap-12 lg:flex-row">
            <div className="intro-column w-full max-w-2xl">
              <h2 className="mb-6 w-full text-2xl font-bold text-gray-900">
                Our Mission
              </h2>
              <p className="mb-6 w-full text-base text-gray-800 md:text-lg">
                At Rake Engineering Consultancy, we are dedicated to delivering
                expert engineering and consultancy services that ensure your
                projects are built with precision and meet all structural and
                compliance standards.
              </p>
              <p className="mb-8 w-full text-base text-gray-800 md:text-lg">
                Our team of certified professionals combines years of experience
                with cutting-edge technology to provide innovative solutions
                that exceed expectations and drive success.
              </p>
              <div className="grid w-full grid-cols-2 gap-6">
                <div className="text-center">
                  <NumberTicker
                    value={50}
                    className="text-3xl font-bold text-orange-600"
                  />
                  <div className="text-slate-500">Projects Completed</div>
                </div>
                <div className="text-center">
                  <NumberTicker
                    value={25}
                    className="text-3xl font-bold text-orange-600"
                  />
                  <div className="text-slate-500">Expert Engineers</div>
                </div>
              </div>
            </div>
            <div className="intro-column w-full max-w-2xl">
              <Image
                src={"/rake.jpg"}
                alt="Rake Logo"
                width={1200}
                height={800}
                className="shadow-lg"
              />
            </div>
          </div>
        </div>
      </article>
    </section>
  );
}

export default AbooutUsIntroduction;
